var React = require('react');

function LeftArrow (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M9.45989 16.2498C9.45989 16.7553 9.13061 17.2111 8.62581 17.4045C8.1203 17.598 7.53962 17.4912 7.15277 17.1335L0.39571 10.8835C0.131974 10.6404 0 10.3201 0 9.99981C0 9.67949 0.131974 9.35996 0.395922 9.11621L7.15299 2.86621C7.53966 2.50855 8.12051 2.40175 8.62603 2.59519C9.13048 2.78847 9.45989 3.24433 9.45989 3.7498V16.2498Z","key":0}),React.createElement("path",{"opacity":"0.4","d":"M20.0009 8.75V11.25C20.0009 11.9402 19.3957 12.5 18.6495 12.5H10.541V7.5H18.6495C19.397 7.5 20.0009 8.05859 20.0009 8.75Z","key":1})]);
}

LeftArrow.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = LeftArrow;

LeftArrow.default = LeftArrow;
